import type { ChangeEvent } from 'react';

import Modal from '../../modal/Modal';
import { ModalHeader } from './ModalHeader';
import { ModalFooter } from './ModalFooter';
import { AlertBanner } from '../../components/AlertBanner';
import { UploadFile } from '../../components/forms/UploadFile';
import { ALLOWED_CATEGORY_MEDIA_EXTENSION_TYPE } from '../categoryMediaConstants';
import { Option } from '../../types/option';

type Props = {
    isOpen: boolean;
    title: string;
    media: string;
    extension: string;
    handleTitleChange: (v: string) => void;
    handleMediaChange: (e: ChangeEvent<HTMLInputElement>) => void;
    handleResetMedia: () => void;
    handleClose: () => void;
    handleConfirm: () => void;
    apiError: Option<string>;
};

export function CategoryUpdateModal({
    isOpen,
    title,
    media,
    extension,
    handleTitleChange,
    handleMediaChange,
    handleResetMedia,
    handleClose,
    handleConfirm,
    apiError,
}: Props) {
    return (
        <Modal isOpen={isOpen} onClose={handleClose} className="min-h-48">
            <div className="flex flex-col items-center w-full gap-3">
                <ModalHeader>Modifier la catégorie</ModalHeader>
                <div className="flex justify-between items-center w-full h-full">
                    <form
                        className="flex flex-col justify-center items-center w-full h-full mt-5 gap-5"
                        onSubmit={e => e.preventDefault()}
                    >
                        <input
                            autoFocus={isOpen}
                            type="text"
                            name="title"
                            placeholder="Titre de votre catégorie"
                            value={title}
                            onChange={e => handleTitleChange(e.target.value)}
                            maxLength={40}
                            required
                        />
                        <div className={'min-w-[300px]'}>
                            <UploadFile
                                media={media}
                                extension={extension}
                                acceptedFormats={ALLOWED_CATEGORY_MEDIA_EXTENSION_TYPE}
                                acceptedFormatsHelper={[
                                    '10Mo max',
                                    '.png',
                                    '.jpg',
                                    '.jpeg',
                                    '.gif',
                                ]}
                                handleMediaChange={(e: ChangeEvent<HTMLInputElement>) => {
                                    e.preventDefault();
                                    handleMediaChange(e);
                                }}
                                handleResetMedia={handleResetMedia}
                            />
                        </div>
                        {apiError.map(v => <AlertBanner>{v}</AlertBanner>).toNull()}
                        <ModalFooter
                            handlePrimaryAction={handleConfirm}
                            handleSecondaryAction={handleClose}
                            disabled={!title.trim() || !media.trim()}
                        />
                    </form>
                </div>
            </div>
        </Modal>
    );
}
